import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-case-practice-ts',
	templateUrl: './case-practice-ts.component.html',
	styleUrls: ['./case-practice-ts.component.css']
})
export class CasePracticeTsComponent implements OnInit {

	constructor() {}

	ngOnInit() {

	}
}



// WEBPACK FOOTER //
// ./src/app/case-practice-ts/case-practice-ts.component.ts